/**
 * @description Do auth for amazon. Redirect to amazon callback uri if it exists or return code for getting token.
 * @param {Object} params
 * @param {string} params.appSlug
 * @param {Object} params.params
 * @param {string} params.apiKey
 * @returns {Promise<void>}
 */
export default async ({ appSlug, params, apiKey }) => {
  if (params.amazon_callback_uri) {
    window.location.href = `${params.amazon_callback_uri}?amazon_state=${params.amazon_state}&state=${apiKey}.${appSlug}`
  } else {
    return {
      code: params.spapi_oauth_code,
      ...params,
    }
  }
}
